import ModelService from '@/contracts/ModelService'
import { http } from '@/plugins/http'
import DataResponse from '@/types/DataResponse'
import PaginatedResponse from '@/types/PaginatedResponse'
import Ability from '@/types/Ability'
import { AxiosResponse } from 'axios'

export default class AbilityService extends ModelService<Ability> {
  index(page: number, filters: string, per_page: number | undefined): Promise<AxiosResponse<PaginatedResponse<Ability>>> {
    return http.get(`/api/v1/office/abilities?page=${page}&${filters}&per_page=${per_page}`)
  }

  show(_id: string): Promise<AxiosResponse<DataResponse<Ability>>> {
    throw new Error('Method not implemented.')
  }

  store(_model: Ability): Promise<AxiosResponse<DataResponse<Ability>>> {
    throw new Error('Method not implemented.')
  }

  update(_id: string, _model: Ability): Promise<AxiosResponse<DataResponse<Ability>>> {
    throw new Error('Method not implemented.')
  }

  destroy(_model: Ability): Promise<AxiosResponse> {
    throw new Error('Method not implemented.')
  }
}
